/**
 * El nombre de un rol base como se lo dice la gente («Administrador», no
 * «COMPANY ADMIN»). Mismo criterio que la lista de Usuarios y la matriz de Roles.
 */
export const NOMBRE_DEL_ROL: Record<string, string> = {
  PLATFORM_ADMIN: 'Super Admin',
  COMPANY_ADMIN: 'Administrador',
  SALESPERSON: 'Vendedor',
  APPROVER: 'Aprobador',
};

/** Un rol que no está en la lista se muestra legible igual: «NUEVO_ROL» → «Nuevo rol». */
export function nombreDelRol(rol: string): string {
  if (NOMBRE_DEL_ROL[rol]) return NOMBRE_DEL_ROL[rol];
  const legible = rol.replace(/_/g, ' ').toLowerCase();
  return legible.charAt(0).toUpperCase() + legible.slice(1);
}
